import { useMemo, useState } from "react";
import { useGetHtmlApiQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import {
  convertDateFormat,
  convertStringToArray,
  convertSymbolCodes,
  getLatestDateFromData,
} from "../Utils/utils";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import Pagination from "../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import PageLastUpdated from "../components/shared/PageLastUpdated";
import useSeo from "../hooks/useSeo";
import { useTableResponsive } from "../hooks/useTableResponsive";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../components/PdfZipItem";

const CareerPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: careersData = [], isLoading: careersIsLoading } =
    useGetProtectedApiDataQuery({ url: "careers", lang: languageType });

  // console.log({ careersData });
  // const a = careersData[0].field_date_of_publication;
  // console.log(new Date(a));

  const {
    data: careerIntroduction = {},
    isLoading: careersIntroductionIsLoading,
  } = useGetHtmlApiQuery({ url: 1197, lang: languageType });
  useTableResponsive(careersData);

  // const careersMainData = careersData.filter(
  //   (item) =>
  //     !item.field_date_of_publication ||
  //     new Date(item.field_date_of_publication) >= new Date()
  // );

  // const careersArchive = careersData.filter(
  //   (item) =>
  //     item.field_date_of_publication &&
  //     new Date(item.field_date_of_publication) < new Date()
  // );

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(careersData);
  }, [careersData]);

  const pageBody =
    careerIntroduction?.body?.[0]?.value ?? "No content available";
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const transformedCareersData = careersData?.map((item) => ({
    ...item,
    field_download: convertStringToArray(item.field_download),
    field_extenral_link: convertStringToArray(item.field_extenral_link),
  }));

  // function filterArchivedDataByDate(data, currentDate) {
  //   console.log({ archivedatabeforeModification: data });
  //   if (!Array.isArray(data)) return []; // Handle null, undefined, or non-array input
  //   return data.filter((item) => {
  //     const fieldDate = new Date(item.field_date_of_publication);
  //     return fieldDate <= new Date(currentDate);
  //   });
  // }

  // function filterArchivedDataByDate(data, currentDate) {
  //   if (!Array.isArray(data)) return [];
  //   return data
  //     .filter((item) => {
  //       const fieldDate = new Date(item.field_date_of_publication);
  //       return fieldDate <= new Date(currentDate);
  //     })
  //     .map((item) => ({
  //       ...item,
  //       field_is_new: "Off",
  //     }));
  // }

  function filterArchivedDataByDate(data, currentDate) {
    if (!Array.isArray(data)) return [];

    const current = new Date(currentDate);

    return data
      .filter((item) => new Date(item.field_date_of_publication) <= current)
      .map((item) => ({
        ...item,
        field_is_new: "Off",
      }));
  }

  const archivedData = filterArchivedDataByDate(
    transformedCareersData,
    new Date(),
  );

  function filterRemainingData(data, archivedData) {
    if (!Array.isArray(data)) return [];
    // Compare and return items not in archivedData
    const archivedTitles = archivedData.map((item) => item.title);

    return data.filter((item) => !archivedTitles.includes(item.title));
  }
  const careerData = filterRemainingData(transformedCareersData, archivedData);

  // sort data
  const sortedArchivedItems = archivedData.sort(
    (a, b) =>
      new Date(b.field_date_of_publication) -
      new Date(a.field_date_of_publication),
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedArchivedItems.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  const totalPages = Math.ceil(sortedArchivedItems.length / itemsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (careersIsLoading || careersIntroductionIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/career"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <section className="ourCompany career-sec">
            <div className="container">
              <div className="row mb-5">
                {/* {pageBody !== "No content available" && ( */}
                <div className="col-12 text-justify">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: convertSymbolCodes(pageBody),
                    }}
                  ></div>
                </div>
                {/* )} */}
                {careerData.length > 0 && (
                  <div className="col-12 mvDescWrap mt-4">
                    <div className="title-sec">
                      <h2>{getText("Latest Openings", "नवीनतम रिक्तियां")}</h2>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-striped custom-table">
                        <thead className="thead-dark">
                          <tr>
                            <th className="no-wrap-td">
                              {getText("S.No.", "क्रमांक")}
                            </th>
                            <th>{getText("Title", "शीर्षक")}</th>
                            {/* <th className="no-wrap-td">
                              {getText("Apply Online", "ऑनलाइन आवेदन करें")}
                            </th> */}
                            <th>{getText("Last Date", "अंतिम तिथि")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {careerData.map((item, index) => (
                            <tr key={index}>
                              <td data-key={getText("S.No.", "क्र. सं.")}>
                                {index + 1}
                              </td>
                              <td data-key={getText("Title", "शीर्षक")}>
                                <div>
                                  <div className="d-flex align-items-center">
                                    <h3>{item.title}</h3>
                                    {item.field_is_new === "On" && (
                                      <img
                                        src="./images/new.gif"
                                        width="20px"
                                        alt={getText("New", "नया")}
                                      />
                                    )}
                                  </div>
                                  {item.field_download.map(
                                    (subitem, subindex) => (
                                      <PdfZipItem
                                        key={subindex}
                                        filePath={subitem?.file_path}
                                        filesize={subitem?.filesize}
                                        title={subitem?.title}
                                      />
                                    ),
                                  )}
                                  {item.field_extenral_link.map((sub, i) => (
                                    <a
                                      href={sub.file_path}
                                      target="_blank" rel="noopener noreferrer"
                                      key={i}
                                    >
                                      {sub.title}
                                    </a>
                                  ))}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.body,
                                    }}
                                  ></div>
                                </div>
                              </td>
                              {/* <td>
                                <a
                                  href={item.field_extenral_link}
                                  target="_blank"
                                >
                                  {getText("Apply", "आवेदन करें")}
                                </a>
                              </td> */}
                              <td
                                className="no-wrap-td"
                                data-key={getText("Last Date", "अंतिम तिथि")}
                              >
                                {convertDateFormat(
                                  item.field_date_of_publication,
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div className="col-12 mvDescWrap mt-4">
                  <div className="title-sec">
                    <h2>{getText("Careers Archive", "कैरियर पुरालेख")}</h2>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-striped custom-table">
                      <thead className="thead-dark">
                        <tr>
                          <th className="no-wrap-td">
                            {getText("S.No.", "क्रमांक")}
                          </th>
                          <th>{getText("Title", "शीर्षक")}</th>
                          <th>{getText("Last Date", "सूची की तिथि")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((item, index) => (
                          <tr key={index}>
                            <td data-key={getText("S.No.", "क्रमांक")}>
                              {indexOfFirstItem + index + 1}
                            </td>
                            <td data-key={getText("Title", "शीर्षक")}>
                              <div>
                                <div className="d-flex align-items-center">
                                  <h3>{item.title}</h3>
                                  {item.field_is_new === "On" && (
                                    <img
                                      src="./images/new.gif"
                                      width="20px"
                                      alt={getText("New", "नया")}
                                    />
                                  )}
                                </div>

                                {item.field_download.map(
                                  (subitem, subindex) => (
                                    <PdfZipItem
                                      key={subindex}
                                      filePath={subitem?.file_path}
                                      filesize={subitem?.filesize}
                                      title={subitem?.title}
                                    />
                                  ),
                                )}
                                {item.field_extenral_link.map((sub, i) => (
                                  <a
                                    key={i}
                                    href={sub.file_path}
                                    target="_blank" rel="noopener noreferrer"
                                  >
                                    {sub.title}
                                  </a>
                                ))}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.body,
                                  }}
                                ></div>
                              </div>
                            </td>
                            <td
                              className="no-wrap-td"
                              data-key={getText("Last Date", "सूची की तिथि")}
                            >
                              {convertDateFormat(
                                item.field_date_of_publication,
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </section>
        </div>
      </div>
    </>
  );
};

export default CareerPage;
